"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _reactReduxI18n = require("react-redux-i18n");

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _documents = require("../../../utils/documents");

var _Icon = _interopRequireDefault(require("../../Icon"));

var _DocumentVersionMenuActions = _interopRequireDefault(require("./DocumentVersionMenuActions"));

var _jsxRuntime = require("react/jsx-runtime");

var validStates = [].concat((0, _toConsumableArray2.default)(_documents.DOCUMENT_STATES_VALID), [_documents.DOCUMENT_STATE.NOT_APPLICABLE]);

function DocumentVersionActions(props) {
  function canNotUpload() {
    return !_documents.DOCUMENT_STATES_CAN_UPLOAD.includes(props.document.state) || !props.documentPermissions.canUpload && !props.documentPermissions.canUploadByMandate;
  }

  function canNotDownload(hasPermission, hasFile) {
    return props.forHeader || !hasPermission || !hasFile || !props.documentPermissions.canDownloadWithInvalidState && !validStates.some(function (state) {
      return state === props.document.state;
    });
  }

  function uploadButton() {
    if (props.document.unpublished || canNotUpload()) {
      return null;
    }

    if (props.document.state === _documents.DOCUMENT_STATE.ALMOST_EXPIRED && !props.showUpdate) {
      return null;
    }

    if (props.forHeader && props.document.state === _documents.DOCUMENT_STATE.REJECTED) {
      return null;
    }

    if (!props.documentPermissions.canUploadByMandate && props.document.collectionMandateEnabled && !props.document.type.gatheredByDepositor) {
      return null;
    }

    var uploadLabel = [_documents.DOCUMENT_STATE.ALMOST_EXPIRED, _documents.DOCUMENT_STATE.EXPIRED].includes(props.document.state) ? _reactReduxI18n.I18n.t('document.uploadUpdate') : _reactReduxI18n.I18n.t('document.upload');

    var handleClick = function handleClick(event) {
      event.preventDefault();
      event.stopPropagation();
      props.documentActions.onUpload(props.document);
    };

    var uploadBo = props.documentPermissions.canUploadByMandate && (!props.documentPermissions.canUpload || props.document.collectionMandateEnabled && !props.document.type.gatheredByDepositor);
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      className: "inline-container small primary no-wrap".concat(uploadBo ? ' bo' : ''),
      title: uploadLabel,
      "data-id": "document-action-upload",
      onClick: handleClick,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "d-none d-lg-inline-block",
        children: uploadLabel
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: "upload"
      })]
    });
  }

  function downloadButton() {
    if (canNotDownload(props.documentPermissions.canDownload, props.document.hasFile)) {
      return null;
    }

    var _props$documentPermis = props.documentPermissions,
        canDownloadWithInvalidState = _props$documentPermis.canDownloadWithInvalidState,
        isBackOffice = _props$documentPermis.isBackOffice,
        canUpload = _props$documentPermis.canUpload;
    var buttonTypeClass = canDownloadWithInvalidState && isBackOffice && !canUpload ? 'bo' : 'secondary';

    var handleClick = function handleClick(event) {
      event.preventDefault();
      event.stopPropagation();
      props.documentActions.onDownload(props.document);
    };

    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      className: "inline-container small no-wrap ".concat(buttonTypeClass),
      title: _reactReduxI18n.I18n.t('document.open'),
      "data-id": "document-action-download",
      onClick: handleClick,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "d-none d-lg-inline-block",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
          value: "document.open"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: "download"
      })]
    });
  }

  function downloadExcel() {
    if (canNotDownload(props.documentPermissions.canDownloadExcel, props.document.hasExcelFile)) {
      return null;
    }

    var handleClick = function handleClick(event) {
      event.preventDefault();
      event.stopPropagation();
      props.documentActions.onDownloadExcel(props.document);
    };

    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      className: "inline-container small secondary no-wrap",
      title: _reactReduxI18n.I18n.t('document.openExcel'),
      "data-id": "document-action-download-excel",
      onClick: handleClick,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "d-none d-lg-inline-block",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
          value: "document.openExcel"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: "download"
      })]
    });
  }

  function downloadProofButton() {
    if (canNotDownload(props.documentPermissions.canDownloadProof, props.document.hasProofFile)) {
      return null;
    }

    var downloadLabel = _reactReduxI18n.I18n.t('document.openProof');

    var handleClick = function handleClick(event) {
      event.preventDefault();
      event.stopPropagation();
      props.documentActions.onDownloadProof(props.document);
    };

    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      className: "inline-container small secondary no-wrap",
      title: downloadLabel,
      "data-id": "document-action-download-proof",
      onClick: handleClick,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "d-none d-lg-inline-block",
        children: downloadLabel
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: "download"
      })]
    });
  }

  function signButton() {
    if (!props.documentPermissions.canSeeSignAction || props.document.state !== _documents.DOCUMENT_STATE.AWAITING_SIGNATURE) {
      return null;
    }

    var canSign = props.documentPermissions.canSign;

    var handleClick = function handleClick(event) {
      event.preventDefault();
      event.stopPropagation();
      props.documentActions.onSign(props.document);
    };

    var button = /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      "data-id": "document-action-sign",
      disabled: !canSign,
      style: canSign ? {} : {
        pointerEvents: 'none'
      },
      type: "button",
      className: "small primary inline-container",
      onClick: handleClick,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: "document.sign"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: "sign"
      })]
    });
    return canSign ? button : /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Tooltip, {
      title: _reactReduxI18n.I18n.t('document.noSignPermission'),
      placement: "left",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: button
      })
    });
  }

  function deleteButton() {
    // The delete button is only shown for the header
    if (!props.forHeader || !(0, _documents.canBeDeleted)(props.document, props.documentPermissions)) {
      return null;
    }

    var handleClick = function handleClick(event) {
      event.preventDefault();
      event.stopPropagation();
      props.documentActions.onDelete(props.document);
    };

    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      "data-id": "document-action-delete",
      type: "button",
      className: "small secondary inline-container",
      onClick: handleClick,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "d-none d-lg-inline-block",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
          value: "document.delete"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: "trash"
      })]
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex-container",
    children: [uploadButton(), downloadProofButton(), downloadExcel(), downloadButton(), signButton(), deleteButton(), !props.forHeader && /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentVersionMenuActions.default, {
      document: props.document,
      documentPermissions: props.documentPermissions,
      documentActions: props.documentActions
    })]
  });
}

DocumentVersionActions.defaultProps = {
  forHeader: false,
  showUpdate: false
};
DocumentVersionActions.propTypes = {
  document: (0, _documents.documentVersionPropTypes)().isRequired,
  documentPermissions: (0, _documents.documentPermissionsPropTypes)().isRequired,
  documentActions: (0, _documents.documentActionsPropTypes)().isRequired,
  showUpdate: _propTypes.default.bool,
  forHeader: _propTypes.default.bool
};
var _default = DocumentVersionActions;
exports.default = _default;
//# sourceMappingURL=DocumentVersionActions.js.map